module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Frageboegen_ro.edb9908b.jpg";